import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import { FCVue } from '@/plugins/vue_init.ts'
import i18next, { TFunction } from 'i18next'
import i18nextConfig from '@/helpers/i18next-config'
import i18NextVue from 'i18next-vue'
import HttpApi from 'i18next-http-backend'
require('./helpers/helpscout.js')

import '@/styles/scss/main.scss'
import '@/styles/scss/fonts.scss'

try {
  i18next.use(HttpApi)
    .init(i18nextConfig)
    .then(() => {

      Vue.prototype.t = Vue.prototype.$t as TFunction;

      interface VueTranslated extends Vue { t: TFunction }
      interface vmWindow extends Window {
        vm: VueTranslated
      }

      (window as vmWindow & typeof globalThis).vm = (new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }) as VueTranslated).$mount('#app')

    })
} catch(e) {
  console.error('Unable to load translations service.', e)
}

Vue.use(i18NextVue, {i18next})

// FreeCycle global Vue filters from fc_common_assets
Vue.use(FCVue)
